import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  LijfrentePremie
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Subscription} from "rxjs";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-lijfrente-premies',
  templateUrl: './lijfrente-premies.component.html',
  styleUrls: ['./lijfrente-premies.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class LijfrentePremiesComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;
    public dialogVisible = false;

    public premieLijfrente = {} as FormGroup

    public omschrijvingLijfrente: SelectFormControlItem<String>[] = [
        {value: "OMZETTING FOR ZONDER STAKING", label: "Omzetting FOR zonder staking"},
        {value: "OMZETTING FOR BIJ STAKING", label: "Omzetting FOR bij staking"},
        {value: "OMZETTING STAKINGSWINST IN LIJFRENTE", label: "Omzetting stakingswinst in lijfrente"},
    ];

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder) {
        this.premieLijfrente = this.fb.group({
            betaaldePremieLijfrente:
                this.fb.array<LijfrentePremie>([], Validators.required),
            lijfrentePremiesFOR:
                this.fb.array<LijfrentePremie>([], Validators.required)
        })
    }

    get betaaldePremieLijfrente(): FormArray {
        return this.premieLijfrente.get('betaaldePremieLijfrente') as FormArray;
    }

    get betaaldePremieLijfrenteFor(): FormArray {
        return this.premieLijfrente.get('lijfrentePremiesFOR') as FormArray;
    }

    addRijPremieLijfrente(): void {
        this.betaaldePremieLijfrente.push(this.createPremieLijfrenteFormGroup()
        )
    }

    addRijPremieLijfrenteFor(): void {
        this.betaaldePremieLijfrenteFor.push(this.createPremieLijfrenteForFormGroup()
        )
    }

    verwijderRijPremieLijfrente(index: number): void {
        this.betaaldePremieLijfrente.removeAt(index);
        this.premieLijfrente.updateValueAndValidity()
        this.premieLijfrente.markAsDirty()
        this.saveForm();
    }

    verwijderRijPremieLijfrenteFor(index: number): void {
        this.betaaldePremieLijfrenteFor.removeAt(index);
        this.premieLijfrente.updateValueAndValidity()
        this.premieLijfrente.markAsDirty()
        this.saveForm();
    }

    createPremieLijfrenteFormGroup(premie?: LijfrentePremie): FormGroup {
        return this.fb.group(({
            omschrijving: premie ? premie?.omschrijving : undefined,
            bedrag: premie ? premie.bedrag : undefined,
            polisnummer: premie ? premie.polisnummer : undefined
        } as LijfrentePremie));
    }

    createPremieLijfrenteForFormGroup(premie?: LijfrentePremie): FormGroup {
        return this.fb.group(({
            omschrijving: premie ? premie?.omschrijving : undefined,
            bedrag: premie ? premie.bedrag : undefined,
            polisnummer: premie ? premie.polisnummer : undefined
        } as LijfrentePremie));
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.premieLijfrente.reset()
                    this.heeftWinst;
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events.pipe(
            filter(
                (event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

  private hasUnsavedChanges(): boolean {
    return this.premieLijfrente.dirty
  }

    private updateForm(): void {
        // gewone lijfrente
        let premieLijfrenteLijst = this.aangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesBetaald || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                premieLijfrenteLijst = this.aangifte?.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesBetaald || [];
            }
        });
        const formArray = this.premieLijfrente.get('betaaldePremieLijfrente') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > premieLijfrenteLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < premieLijfrenteLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(premieLijfrenteLijst[i]);
            } else {
                const formGroup = this.createPremieLijfrenteFormGroup(premieLijfrenteLijst[i]);
                formArray.push(formGroup);
            }
        }

        // FOR
        const premieLijfrenteFORLijst = this.aangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesFOR || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                premieLijfrenteLijst = this.aangifte?.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesFOR || [];
            }
        });
        const formArray2 = this.premieLijfrente.get('lijfrentePremiesFOR') as FormArray;

        while (formArray2.length > premieLijfrenteFORLijst.length) {
            formArray2.removeAt(formArray2.length - 1);
        }

        for (let i = 0; i < premieLijfrenteFORLijst.length; i++) {
            if (i < formArray2.length) {
                const control = formArray2.at(i) as FormGroup;
                control.patchValue(premieLijfrenteFORLijst[i]);
            } else {
                const formGroup2 = this.createPremieLijfrenteForFormGroup(premieLijfrenteFORLijst[i]);
                formArray2.push(formGroup2);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    uitgavenVoorInkomensvoorzieningen: {
                        ...this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen,
                        lijfrentePremiesBetaald: this.premieLijfrente.value.betaaldePremieLijfrente,
                        lijfrentePremiesFOR: this.premieLijfrente.value.lijfrentePremiesFOR
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        uitgavenVoorInkomensvoorzieningen: {
                            ...this.aangifte.partnerAangifte?.box1?.uitgavenVoorInkomensvoorzieningen,
                            lijfrentePremiesBetaald: this.premieLijfrente.value.betaaldePremieLijfrente,
                            lijfrentePremiesFOR: this.premieLijfrente.value.lijfrentePremiesFOR

                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
      this.premieLijfrente.markAsDirty()
    }

    get heeftWinst(): boolean {
        if (this.partnerBoolean) {
            return this.aangifte?.partnerAangifte?.box1?.winstUitOnderneming !== undefined;
        } else {
            return this.aangifte?.box1?.winstUitOnderneming !== undefined;
        }
    }

}
